import React from "react";
import "./Products.css";
import About_Product_Tabs from "./about_product_tabs/About_Product_Tabs";
import Product_Info from "./product_info/Product_Info";
import SwiperCard from "./../home/swiper_card/SwiperCard"
import TestimonialSwiper from './../home/testimonials_section/TestimonialSwiper';

const Products = () => {
  return (
    <section className="Products">
      <Product_Info/>
      <About_Product_Tabs/>
      <SwiperCard/>
       <TestimonialSwiper/>
    </section>
  );
};

export default Products;
